export default {
    tabbar: {
        home: 'Home',
        trading: 'Trading',
        invest: 'Invest',
        share: 'Share',
        mine: 'Mine'
    },
    common: {
        deposit: 'Deposit',
        withdrawal: 'Withdrawal',
        share: 'Share',
        team: 'Team',
        task: 'Task',
        addr: 'Address',
        logout: 'Logout',
        wallet: 'Wallet',
        account: 'Account',
        promotion: 'Promotion',
        details: 'Details',
        dailyRevenue: 'daily revenue',
        dailyRevenueList: 'Daily Revenue List',
        aboutUs: 'About us',
        globalPartners: 'Global partners',
        totalBalance: 'Total Balance',
        profitList: 'Financial Profit List',
        notification: 'Notification',
        previous: 'Previous',
        close: 'Close',
        next: 'Next',
        investWallet: 'Investment Wallet',
        financialWallet: 'Financial Wallet',
        recharge: 'Recharge',
        copySucceeded: 'copy succeeded',
        copyFailed: 'copy failed',
        promotionWallet: 'Promotion Wallet',
        registerRewardWallet: 'Register reward Wallet',
        toAddress: 'TRON wallet address(Start with T) for collection',
        verifyYourPassword: 'Verify your security password',
        serviceFee: 'Gas fees',
        confirm: 'Confirm',
        submitted: 'submitted',
        date: 'Date',
        amount: 'Amount',
        accountAvailableBalance: 'Account available balance',
        securityPassword: 'Security password',
        withdrawalPrincipal: 'Withdrawal of principal',
        withdrawalProfit: 'Withdrawal of profits',
        profitRate: 'Interest rate',
        notificationAndFAQ: 'FAQ & Notices',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Project features/introduction',
                content: `R:
1. As the industry’s first and proven audited investment code, our solution aims to prove that smart contracts are the future of investing. Its longevity and stability will ultimately disrupt the crypto industry and the way people think about investing and trading. The conventional token industry faces many challenges, including token scams, rugs, market volatility, dishonest developers stealing user funds, and lack of liquidity.

2. The reliability code we have is based on the structure of the solution and our solution will not be affected in any way by these and many other challenges that arise in the crypto industry. Our platform does not require market liquidity. Therefore, your investment and expected income are safe because we are not dependent on changes in the industry. Instead, we built a solution based on new user appeal but running on smart contracts! Our code and structure are secure, with guaranteed longevity and transparency. Therefore, we have a very attractive and robust referral program with detailed and transparent statistics for each promoter/user. The originator’s earnings, as well as those of other users, are instantly added to the profile, and unlike other DeFi investment solutions, people can instantly withdraw funds at any time.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:What is our advantage?',
                content: `R:Our systems are audited by the Haze security team and have independent Smart Contract auditors
1. Safe and reliable: no need to transfer currency, USDT is deposited into your own wallet with zero risk
2. Professional stability: professional team, stable operation throughout the year
3. Low entry threshold: share node mining income
4.USD ETHW AI Strategy-C Mining Pool: No need to transfer currency, stable income
5. We are committed to building the world’s largest integrated DeFi platform DEX, IMO, and DAO`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:How do I get involved?',
                content: `R:
1. The wallet is on the chain, and the wallet station is equipped with a Dapp browser.
2. Connect TRC20 to USDT and deposit it into your wallet
3. Enter Gongwang through the wallet browser
4. Your wallet must have more than 30 trx as mining fees to participate in this project
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:How long does it take to participate in mining?',
                content: `R:Time cannot be calculated. Normally it can be completed within 4 hours. If other uncertain reasons are encountered, the time may be extended.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Why do we need to pay mining fees to cash out profits?',
                content: `R:Because in this process of participating in mining, customers are only counted by name, and the mining fees generated have been paid by the miners. The income generated is actually in the contract pool, and only by paying mining fees can you exchange for income.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:How to withdraw profits?',
                content: `R:After obtaining USDT, you must have a small amount of TRX in your wallet for transaction fees. You only need to pay once, and the USDT exchange will be completed within one legal working day. When you initiate a withdrawal, the USDT withdrawal will be automatically sent to the wallet address of the node you joined. Other addresses are not supported.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:What is Defi liquidity mining?',
                content: `R:Liquidity mining is a type of DeFi decentralized finance. It does not need to purchase graphics cards, contribute computing power, or pay expensive electricity bills, but earns income by providing funds and liquidity. Especially recently, currency prices have fluctuated greatly. For some committed coin holders, liquidity mining is a way to earn income and accumulate more cryptocurrency without the need for transactions.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:How does it work?',
                content: `R:Our solution is a computerized transaction agreement that automatically enforces the terms of a contract between two parties. Similar to universal contracts, both users on our platform must define the rules and terms of participation when trading. Once an agreement is reached and a smart contract is launched, it operates as designed, with zero chance of changes to the predetermined conditions. When a user initiates an activity in the mining pool of a blockchain node, there must be an available balance on the contract. The rest of the users leave it to the contract to execute, no longer having to wait long hours to check when to sell or buy. Therefore, according to the terms of the contract, the value of your investment is guaranteed to never decrease; on the contrary, it brings 100% profit to our users.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'The withdrawal amount must be greater than the gas fee consumed',
        supportTips: 'Dear user: We have set up an exclusive mining pool assistant service for you. You can write to us for consultation, complaints, suggestions, etc., and we will reply and handle it within 24 hours!',
        tips: 'Tips',
        Withdrawals_prohibited: 'The withdrawal conditions are not currently met, please complete the task first.'
    },
    homePage: {
        theCommonProblem: 'The common problem',
        latestAnnouncement: 'Latest Announcement',
        block5title: 'Join to be a TRON Millionaire',
        block5desc: 'Use cloud mining and Defi technology to ensure that all users get the most USDT revenue.',
        block6title: 'Platform data display',
        accumulatedProfit: 'Accumulated profit',
        membership: 'Membership',
        block7title: 'We are at our best',
        block7desc: 'hako is a company registered in Singapore, license number: PS20200556. We are the only audited and verified smart contract investment website in the cryptocurrency space operating on the TRON Smart Chain (TRON) network. hako cloud mining offers a potentially cost-effective mining pipeline for Bitcoin USDT and other cryptocurrencies. At the same time, both quantitative trading and DeFi technology will allow you to easily participate in blockchain transactions with a small amount of capital and obtain stable income such as insurance.',
        tzl: 'invested',
        zl: 'earned'
    },
    investPage: {
        productList: 'Product List',
        investedList: 'Invested List',
        dailyRate: 'Daily rate',
        cycle: 'cycle',
        day: 'Day',
        productDetails: 'Product Details'
    },
    tradingPage: {
        miningWorking: 'Cloud Mining is working',
        tradingProfit: 'Trading profit',
        settlementRule: '24-hour settlement',
        viewAll: 'View all',
        quantifyingTransactionRevenue: 'Qualitative Trading Income',
        receive: 'Receive',
        received: 'Received',
        rule: 'Mining rules',
        rules: 'If you want "Cloud Mining" to start working and earn you daily income, please activate it in "Financial Wallet". When the USDT balance in your wallet meets certain conditions, you will receive a daily income, and the generated income will be retained for 30 days. Please click to claim it in time. Calculate your daily revenue percentage based on the table below:',
        profit: 'Profit',
        miningNotWorking: 'Cloud mining is not working, please activate it',
        balance: 'balance'
    },
    sharePage: {
        text1: 'Invite your contacts',
        text2: 'or Friends and Earn Rewards',
        text3: 'Refer and Earn Rewards',
        text4: 'Share your referal link and start earning',
        copyLink: 'Copy Link'
    },
    minePage: {
        trxDepositInvestment: 'USDT Deposit investment',
        trxDepositFinancial: 'USDT Deposit financial',
        tips: 'Recharge any number of USDT to activate the account and open the withdrawal function.',
        appServices: 'App Services'
    },
    depositPage: {
        text1: 'Investment is divided into two modes',
        text2: '1:Recharge into the Investment wallet,you can receive income according to different cycles, Return the principal and income upon maturity',
        text3: '2:Activate the "cloud mining" function in your financial wallet, and receive income according to the Singapore time zone (after 12o’clock)everry day',
        text4: 'Note:',
        text5: 'Before investing,please choose a investment account or an financial account to invest according to your investment needs.Plesase be sure to wait for the account to be recharged.This is a very critical issue. '
    },
    rechargePage: {
        trxAddress: 'TRC20-USDT Address',
        copyAddress: 'Copy address',
        tips1: 'Please don’t recharge other non USDT assets. It will be recorded about 5~10 minutes after charging.',
        tips2: `If it hasn't arrived for a long time, please refresh this page. Minimum 5 USDT investment.`,
        rechargeCompleted: 'Recharge completed',
        inactivated: 'Inactivated',
        activated: 'Activated',
        tips3: 'No need to click repeatedly. Cloud mining starts working about 5 to 10 minutes after the request is sent.',
        tips4: 'If it has not been activated for a long time, please click the activate button again.',
        ActivateCloudMining: 'Activate cloud mining'
    },
    withdrawalPage: {
        text1: 'Basic account balance(USDT)',
        text2: 'The withdrawal will be received within 24 hours',
        dailyWithdrawalLimit: 'Daily withdrawal limit',
        unlimit: 'unlimit'
    },
    teamPage: {
        intro: 'Users you invite directly and indirectly can earn dividends for you. Suppose you invite user A, the financial income gained by user A will be sent to your wallet as a percentage reward. If user A invites user B, and B in turn invites C, you can get A ({lev2rate}%), B ({lev3rate}%), C ({lev4rate}%) percentage reward of user income!',
        level: 'Level',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Quantity',
        rewards: 'Rewards'
    },
    productDetailsPage: {
        startingAmount: 'Starting amount',
        maxInvestmentAmount: 'Max investment amount',
        dailyInterestRate: 'Daily interest rate',
        investableQuantity: 'Investable quantity',
        investmentAmount: 'Investment amount',
        participateInInvestment: 'Participate in investment'
    },
    investedListPage: {
        investmentTime: 'Investment time',
        settlementTime: 'Settlement time',
        settlementAmount: 'Settlement Amount'
    },
    loginPage: {
        MobileNumber: 'Mobile number',
        LoginPassword: 'Login password',
        SignIn: 'Sign in',
        SignUp: 'Sign up',
        rememberThePassword: ' remember the password',
        inviteCode: 'Invite code',
        captcha: 'Captcha',
        EncryptedRegistration: 'Encrypted registration',
        desc: 'The password is stored in a decentralized way and cannot be retrieved after it is lost. Please remember your password. ',
        registerSuccess: 'Account created successfully'
    },
    taskPage: {
        desc: 'Each effective recharge amount of the subordinate members you invite to register will be converted into your withdrawal limit (promotion reward account) in a certain proportion',
        rwconvertRate: 'Conversion scale',
        totalLimit: 'Cumulative limit',
        availableLimit: 'Available Credit',
        contactService: 'Contact customer service'
    },
    Please_unlock_your_wallet: 'Please unlock your wallet',
    Please_open_the_website_in_the_Dapp_browser: 'Please open the website in the Dapp browser'
}
